import * as Yup from "yup";

export const dataModel = {
  type: "",
  code: "",
  varietyCode: "",
  calibreCode: "",
};

export const validationDataModel = Yup.object().shape({
  code: Yup.string().optional(""),
  type: Yup.number().optional(""),
  varietyCode: Yup.string().optional(""),
  calibreCode: Yup.string().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
